"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledMenuItem = void 0;
const ui_components_1 = require("@groupby/ui-components");
const styled_components_1 = __importDefault(require("styled-components"));
exports.StyledMenuItem = (0, styled_components_1.default)(ui_components_1.MenuItem) `
  && {
    padding: ${({ theme }) => theme.spacing(1.5, 2)};
    margin: 0;
  }
`;
